// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5216) return "static/chunks/db64a1d0-52aedcd0dc89d49d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "d2fe85d7b5d53c33" + ".js";
};